import React from 'react';
import { DEPARTMENT_FILTER, FilterProps } from './types';
import TeamCalendarMultipleFilter from './TeamCalendarMultipleFilter';
import { useObjectLabels } from '../../../../../hooks/useObjectLabels';

const DepartmentFilter: React.FC<React.PropsWithChildren<FilterProps>> = ({
  options,
  filterData,
}) => {
  const objectLabels = useObjectLabels();

  return (
    <TeamCalendarMultipleFilter
      options={options}
      filterData={filterData}
      filterKey={DEPARTMENT_FILTER}
      placeholder={objectLabels.department}
    />
  );
};

export default DepartmentFilter;
